// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"02bb1f8d","742":"fefa241c"}[chunkId] + ".js";
};